// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__tableBox--NgOH3 {
  flex: 1;
  min-width: 50%;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__header--mUwTN {
  display: grid;
  overflow: hidden;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__body--J6OGE {
  flex: 1;
  overflow: auto;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__cells--J2KXd {
  display: grid;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__cells--J2KXd .ant-input-number {
  background: none;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__borderTop--M_roi {
  border-top: thin solid rgba(0, 0, 0, 0.12);
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__borderLeft--AOMhi {
  border-left: thin solid rgba(0, 0, 0, 0.12);
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__borderRB--Z2Y7f {
  border-right: thin solid rgba(0, 0, 0, 0.12);
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__emptyBox--rehio {
  padding: 16px 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__th--r2UXk {
  padding: 4px 8px;
  color: rgba(0, 0, 0, 0.55);
  background: #fafafa;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__baseSizeCell--pRL8X {
  background-color: rgba(133, 165, 255, 0.1);
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__leftAlign--kMvIf {
  text-align: left;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__rightAlign--CqInM {
  text-align: right;
}
.src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__centerAlign--cNeYK {
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsMeasurementChart2/Mc2Summary/Mc2Entity/Mc2Table/Mc2Table.module.less"],"names":[],"mappings":"AAAA;EACE,OAAA;EACA,cAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;AACF;AACA;EACE,aAAA;EACA,gBAAA;AACF;AACA;EACE,OAAA;EACA,cAAA;AACF;AACA;EACE,aAAA;AACF;AAFA;EAGI,gBAAA;AAEJ;AAIA;EACE,0CAAA;AAFF;AAIA;EACE,2CAAA;AAFF;AAIA;EACE,4CAAA;EACA,6CAAA;AAFF;AAKA;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAHF;AAMA;EACE,gBAAA;EACA,0BAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAJF;AAOA;EACE,0CAAA;AALF;AAQA;EACE,gBAAA;AANF;AAQA;EACE,iBAAA;AANF;AAQA;EACE,kBAAA;AANF","sourcesContent":[".tableBox {\n  flex: 1;\n  min-width: 50%;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n}\n.header {\n  display: grid;\n  overflow: hidden;\n}\n.body {\n  flex: 1;\n  overflow: auto;\n}\n.cells {\n  display: grid;\n  :global(.ant-input-number) {\n    background: none;\n  }\n}\n\n@border: thin solid rgba(0, 0, 0, 0.12);\n\n.borderTop {\n  border-top: @border;\n}\n.borderLeft {\n  border-left: @border;\n}\n.borderRB {\n  border-right: @border;\n  border-bottom: @border;\n}\n\n.emptyBox {\n  padding: 16px 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.th {\n  padding: 4px 8px;\n  color: rgba(0, 0, 0, 0.55);\n  background: #fafafa;\n  font-family: Inter;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 150%;\n}\n\n.baseSizeCell {\n  background-color: rgba(133, 165, 255, 0.1);\n}\n\n.leftAlign {\n  text-align: left;\n}\n.rightAlign {\n  text-align: right;\n}\n.centerAlign {\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableBox": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__tableBox--NgOH3`,
	"header": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__header--mUwTN`,
	"body": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__body--J6OGE`,
	"cells": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__cells--J2KXd`,
	"borderTop": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__borderTop--M_roi`,
	"borderLeft": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__borderLeft--AOMhi`,
	"borderRB": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__borderRB--Z2Y7f`,
	"emptyBox": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__emptyBox--rehio`,
	"th": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__th--r2UXk`,
	"baseSizeCell": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__baseSizeCell--pRL8X`,
	"leftAlign": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__leftAlign--kMvIf`,
	"rightAlign": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__rightAlign--CqInM`,
	"centerAlign": `src-businessServices-services-bsMeasurementChart2-Mc2Summary-Mc2Entity-Mc2Table-Mc2Table-module__centerAlign--cNeYK`
};
export default ___CSS_LOADER_EXPORT___;
